import { render, staticRenderFns } from "./DonneesSinistre.vue?vue&type=template&id=f65bded2&scoped=true"
import script from "./DonneesSinistre.vue?vue&type=script&lang=js"
export * from "./DonneesSinistre.vue?vue&type=script&lang=js"
import style0 from "./DonneesSinistre.vue?vue&type=style&index=0&id=f65bded2&prod&scoped=true&lang=css"
import style1 from "./DonneesSinistre.vue?vue&type=style&index=1&id=f65bded2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f65bded2",
  null
  
)

export default component.exports